import { useEffect, useState } from 'react';
import Link from './link';
import { useTheme } from '../contexts/ThemeContext';

function Header() {
  const { theme, toggleTheme } = useTheme();
  const [showMenu, setShowMenu] = useState(false);

  useEffect(() => {
    document.title = window.Config.SiteName;
  }, []);

  return (
    <div id='header'>
      <div className='container'>
        <h1 className='logo'>{window.Config.SiteName}</h1>
        <div className='mobile-toggle' onClick={() => setShowMenu(!showMenu)}>
          {showMenu ? '✕' : '☰'}
        </div>
        <div className={`navi ${showMenu ? 'open' : ''}`}>
          {window.Config.Navi.map((item, index) => (
            <Link key={index} to={item.url} text={item.text} />
          ))}
          <span className='theme-toggle' onClick={toggleTheme}>
            {theme === 'auto' ? '🌗' : theme === 'dark' ? '🌙' : '☀️'}
          </span>
        </div>
      </div>
    </div>
  );
}

export default Header;
